import { changeLocale } from 'auth/actions/session.actions';
import { saveUserLocale } from 'user/resources/user.api';
import { checkAccess } from 'app/actions/app.actions';
import { getDisplayUserNameSelector } from 'selectors';
import cloneDeep from 'lodash/cloneDeep';
import topMenuTemplate from './top-menu.html';

const mapStateToThis = (state) => {
  const { session, messages, config } = state;
  const displayUserName = getDisplayUserNameSelector(state);
  const { locale, topmenu, loggedIn, impersonatingDisplayName, isAdmin } = session;
  const { unreadCount } = messages;
  const { locales, defaultLocale } = config;
  const applicationName = config.applicationName[locale];
  const availableLocales = cloneDeep(locales);
  if (locales.length === 1 && locales[0].code !== 'en_US' && loggedIn && isAdmin) {
    availableLocales.push({ code: 'en_US', label: 'English' });
  }

  return {
    displayUserName,
    locale,
    availableLocales,
    unreadCount,
    session,
    topmenu,
    loggedIn,
    impersonatingDisplayName,
    isAdmin,
    locales,
    defaultLocale,
    applicationName,
  };
};

const mapDispatchToThis = {
  changeLocale,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'tmhDynamicLocale')
class TopMenuController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.saveUserLocale = saveUserLocale;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  shouldDisplayRetailerSettings() {
    return this.topmenu.retailerSettings && this.topmenu.retailerSettings.hasAccess;
  }

  async onChangeLocale(locale) {
    const isLocaleChanged = locale !== this.session.locale;
    this.setDynamicLocale(locale);
    this.changeLocale(locale);

    if (this.session.loggedIn && isLocaleChanged) {
      await this.saveUserLocale(this.session.id, locale);
    }

    if (isLocaleChanged) {
      this.$state.go(this.$state.current.name, null, { reload: true });
    }
  }

  setDynamicLocale(locale) {
    const formattedLocale = locale.toLowerCase().replace('_', '-');
    this.tmhDynamicLocale.set(formattedLocale);
  }
}

export default class TopMenuComponent {
  constructor() {
    this.controller = TopMenuController;
    this.template = topMenuTemplate;
    this.transclude = true;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/top-menu/top-menu-component.js